import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import ErrorBoundary from "@Components/ErrorBoundary";

const ListDesktop = loadable(() => import("./ListDesktop"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => (
  <ErrorBoundary>
    <ListDesktop {...props} />
  </ErrorBoundary>
);
